'use client'

import {useEffect} from 'react'
import {GlobalErrorPage} from '@fitro/error-ui'
import {captureException} from '@fitro/customer-features/lib/client-logger'

export default function GlobalError({error, retry}: {error: Error & {digest?: string}; reset: () => void; retry: () => void}) {
    useEffect(() => {
        captureException(error, {
            event: 'next_global_error',
            source: 'app/global-error',
            message: 'Global error boundary captured an exception',
            context: {digest: error.digest ?? null},
        })
    }, [error])

    return (
        <html lang="pl">
        <head><title>Problemy techniczne | Fitro</title></head>
        <body><GlobalErrorPage retry={retry} fallbackHref="/calendar" logoSrc="/logo.svg" heroSrc="/fitro-error-recovery.webp"/></body>
        </html>
    )
}
